/*globals $ */

class MenuListItem {
  constructor(app, $el) {

    this.app                = app;
    this.$el                = $el;
    this.$dropdown          = this.$el.find('.Dropdown');
    this.$dropdownContent   = this.$dropdown.find('.Dropdown__content');

    this.isHover            = false;
    this.dropdownWidth      = Number(this.$dropdown.attr('data-width'));
    this.onCompleteFadeout  = true;
    this.isTablet           = false;
    this.isOpen = false;

    if($('html').hasClass('ua-tablet')) {
      this.isTablet = true;
    }

    this.$dropdownContent.css({
      'width':        this.dropdownWidth,
      'margin-left':  -Math.floor(this.dropdownWidth / 2)
    });

    if(this.isTablet) {
      let touchTarget = this.$el.children('.GNavListItem__btn');
      if(this.$el.children('.GNavListItem__btn').length == 0) {
        touchTarget = this.$el.children('.BtnToggleMenu');
      }

      touchTarget.on('touchstart', () => {
        if(touchTarget.attr('href') != undefined) {
          if(!this.isOpen) {
            this.isOpen = true;
            this.mouseoverAction();
            return false;
          }
        } else {
          if(this.isOpen) {
            this.isOpen = false;
            this.mouseoutAction();
          } else {
            this.isOpen = true;
            this.mouseoverAction();
          }
        }
      });
    } else {
      this.$el.mouseover(() => {
        this.mouseoverHandler();
      });

      this.$el.mouseout(() => {
        this.mouseoutHandler();
      });

      this.$dropdown.mouseover(() => {
        this.mouseoverHandler();
      });

      this.$dropdown.mouseout(() => {
        this.mouseoutHandler();
      });
    }

  }

  mouseoverHandler() {
    clearInterval(this.mouseoutTimer);
    if(!this.isHover && this.onCompleteFadeout) {
      this.isHover = true;
      this.mouseoverAction();
    }
  }

  mouseoutHandler() {
    clearInterval(this.mouseoutTimer);
    this.mouseoutTimer = setInterval(() => {
      clearInterval(this.mouseoutTimer);
      if(this.isHover) {
        this.isHover = false;
        this.mouseoutAction();
      }
    }, 100);
  }

  mouseoverAction() {
    let menuCenterPos = this.$el.offset()['left'] + this.$el.width() / 2;
    let menuRightPos = Math.floor(menuCenterPos + 20 + this.dropdownWidth / 2) + 1;

    let limitPos = menuCenterPos + 160;
    if(this.isTablet) {
      limitPos = this.app.windowWidth;
    }

    if(menuRightPos > limitPos) {
      let remainWidth = limitPos - menuCenterPos;
      this.$dropdownContent.css({
        'margin-left': -(this.dropdownWidth - remainWidth)
      });
    } else {
      this.$dropdownContent.css({
        'margin-left':  -Math.floor(this.dropdownWidth / 2)
      });
    }

    this.$dropdown
      .stop(false)
      .css({'opacity':0, 'display':'block', 'margin-top':-10})
      .animate({'opacity': 1, 'margin-top': 0}, 300, 'easeOutExpo');
    // this.$dropdown.css('display', 'block');
  }

  mouseoutAction() {
    this.onCompleteFadeout = false;
    this.$dropdown.stop(false).animate({'opacity': 0, 'margin-top': -10}, 500, 'easeOutExpo', () => {
      this.$dropdown.css('display', 'none');
      this.onCompleteFadeout = true;
    });
    // this.$dropdown.css('display', 'none');
  }
}

export default MenuListItem;
